import { render } from "./TheFooter.vue?vue&type=template&id=dd66f682"
import script from "./TheFooter.vue?vue&type=script&lang=js"
export * from "./TheFooter.vue?vue&type=script&lang=js"

import "./TheFooter.vue?vue&type=style&index=0&id=dd66f682&lang=scss"
script.render = render

export default script